import cardOperationRouters from './card-operation/routers'
import certificationAuditRouters from './certification-audit/routers'
import myRecordRouters from './my-record/routers'
import writeOffOperation from './write-off-operation/routers'

export default [
  ...cardOperationRouters,
  ...certificationAuditRouters,
  ...myRecordRouters,
  ...writeOffOperation
]



// WEBPACK FOOTER //
// ./src/pages/wx-member/go-out-management/routers.js